import React, { useEffect, useState, useContext } from "react";
import { AppContext } from "../../context/AppContext";

import '../../../src/pages/Styles/InvStyle.css'

export default function Toptab({ activeTab, setActiveTab, tabs }) {

    const { sidebar, setSidebar, Dark, setDark } = useContext(AppContext);

    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);


    return (
        <div
            className={sidebar ? "taskMain " : "cx-active taskMain"}
            id="cx-main"
        >
            <div className="full-backgrounds">
                {/* Tab Navigation */}
                {/* 
      <div className="top-tv-3">Menu List</div> */}
                <div className="top-tv-4">
                    <div
                        className="flex border-b  col-md-12 border-top border-bottom  bg-light top-inv1 "
                        style={{ flexDirection: isSmallScreen ? "column" : null }}
                    >
                        {tabs.map((tab) => (
                            <button
                                style={{
                                    borderTopLeftRadius: "7px",
                                    borderTopRightRadius: "7px",
                                }}
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`py-2 px-4 text-sm font-medium font-size-14   font-family flex-1  
              ${activeTab === tab.id
                                        ? "   text-blue-600 font-weight-600 top-t2 "
                                        : "border-none  bg-light font-weight-500"
                                    }
              ${tab.disabled ? "text-light-400  cursor-not-allowed" : ""}
            `}
                                disabled={tab.disabled}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>
                    <div className="">
                        {tabs.map(
                            (tab) =>
                                activeTab === tab.id && (
                                    <div key={tab.id} className="text-gray-700">
                                        {tab.content}
                                    </div>
                                )
                        )}
                    </div>
                </div>
                {/* Tab Content */}
            </div>
        </div>
    );
}
